export const tutorialsConstants = {
    SHOW_ONBOARDING: 'SHOW_ONBOARDING',
    SHOW_FILE_VIEWER_TUTORIAL: 'SHOW_FILE_VIEWER_TUTORIAL',
};